// extracted by mini-css-extract-plugin
export default {"Categories":"Categories_Categories__TXD3-","Category":"Categories_Category__EJjkY","CategoryActive":"Categories_CategoryActive__zIK+d"};